import React, { useState, useEffect } from "react";
import "../i18n/config";
import i18next from "i18next";
import apiService from "../services/api.service";
import { Link, useLocation, useHistory } from "react-router-dom";
import FileSaver from "file-saver";
import { Document, Page, pdfjs } from "react-pdf";
import { ErrorCodes } from "../data/enums";
import { useTranslation } from "../hooks/useTranslation";


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


function VoucherComponent() {


    const [lang, setLang] = useState("");
    const { t } = useTranslation();
    const location = useLocation();
    const chainId = new URLSearchParams(location.search).get("chainid") || 0;
    const history = useHistory();
    const [voucherpdf, setVoucherpdf] = useState("");



    const SetLanguage = (l) => {
        i18next.changeLanguage(l);
    };

    useEffect(() => {
        setLang(new URLSearchParams(location.search).get("lang") || "eng");
        getVoucher();

    }, []);

    useEffect(() => {
        SetLanguage(lang);
    }, [lang]);



    const getVoucher = async () => {
        let token = new URLSearchParams(location.search).get("t")
        if (token) {
            try {
                const filename = 'iShop_voucher.pdf';
                let res = await apiService.getVoucher(token);
                FileSaver(res.data, filename);
                setVoucherpdf(res.data);
            }
            catch (err) {
                console.error(err);
                alert(t("SomethingWentWrong") + "\n" + t("ErrorCode") + ErrorCodes.GetVoucher);
            }

        }
    };

    return (<>
        <div className="voucherPdfWrap">
            <Document file={voucherpdf} loading={"Loading ..."} noData={"Loading ..."}>
                <Page pageNumber={1} className="pdfWidgh" />

            </Document>
        </div>
    </>);
}

export default VoucherComponent;
